<template>
    <v-container>
        <v-row class="mx-0">
            <v-col cols="12" class="d-flex justify-center">
                <v-card width="100%" max-width="800px">
                    <div class="d-flex justify-center title pa-4 text-center">{{ $t('orderSuccess') }}</div>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row
                            dense
                            v-for="order in responseSuccessArr"
                            :key="order.seller.id"
                        >
                            <v-col cols="12" class="title">{{ order.seller.name }}</v-col>
                            <v-col cols="12">
                                <v-data-table
                                    hide-default-footer
                                    disable-sort
                                    disable-pagination
                                    class="no-mobile-header"
                                    :footer-props="{ disablePagination: true }"
                                    :header-props="{ disableSort: true }"
                                    :headers="headersGroupGeneral"
                                    :items="order.products"
                                ></v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex flex-wrap justify-center justify-md-space-around">
                        <v-btn
                            class="px-4 my-4 test-white"
                            color="main--yellow"
                            depressed
                            :disabled="!basketItems.length"
                            :to="{ name: 'checkout' }"
                        >{{ $t('backToOrders') }}
                        </v-btn>
                        <v-btn
                            class="px-4 my-4 test-white"
                            :to="{ name: 'profileBasket' }"
                            color="main--yellow"
                            dark
                            depressed
                        >{{ $t('myBasket') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import OrderDataProvider from '../../../app-front/mixins/OrderDataProvider';
    import numberFormat from "../../../utils/numberFormat";

    export default {
        name: 'CheckoutSuccess',
        mixins: [
            OrderDataProvider,
        ],
        data() {
            return {
                headersGroupGeneral: [
                    {
                        text: 'Товар',
                        align: 'start',
                        value: 'name',
                    },
                    {
                        text: 'Номер заказа',
                        align: 'start',
                        value: 'orderNumber',
                    },
                    {
                        text: 'Кол-во',
                        align: 'start',
                        value: 'quantity',
                    },
                    {
                        text: 'Цена',
                        align: 'start',
                        value: 'price',
                    },
                    {
                        text: 'Поставка',
                        align: 'start',
                        value: 'dateDelivery',
                    },
                    {
                        text: 'Статус',
                        align: 'start',
                        value: 'status',
                    },
                ],
            }
        },
        computed: {
            responseSuccessArr() {
                return this.orderData.responseSuccessData.map(item => {
                    return {
                        seller: item.seller,
                        products: item.products.map(product => {
                            const price = product.priceDiscounted ? product.priceDiscounted : product.price
                            return {
                                name: product.name,
                                orderNumber: product.orderNumber,
                                quantity: product.quantity,
                                price: numberFormat(price, 2, '.', ' '),
                                dateDelivery:  product.dateDelivery,
                                status: product.status
                            }
                        })
                    }
                });
            },
        },
        beforeRouteLeave(to, from, next) {
            this.resetCurrentOrderData();
            this.clearStorageResponseData();

            next();
        },
        created() {
            if(window.gtag) {
                this.responseSuccessData.forEach(seller => {
                    seller.products.forEach(product => {
                        const price = product.priceDiscounted ? product.priceDiscounted : product.price
                        window.gtag('event', 'purchase', {
                            "transaction_id": product.orderNumber,
                            "affiliation": seller.companyName ? seller.companyName : `${seller.firstName} ${seller.lastName}`,
                            "value": price,
                            "currency": "UAH",
                            "items": [
                                {
                                    "id" : product.id,
                                    "name" : product.name,
                                    "brand": seller.name,
                                    "category" : product.category,
                                    "variant": product.packValue,
                                    "quantity": product.unitQuantity,
                                    "price": price
                                }
                            ]
                        })
                    })

                });
            }
            if (!this.orderResponseData) {
                this.$router.push({ name: 'Basket' });
            }
        },
    }
</script>

<style scoped>

</style>
